export interface Municipality {
  name: string
  cap: string[]
  province: string
}

export const MUNICIPALITIES_FILE = 'assets/municipalities.json';


